export default __webpack_public_path__ + "static/media/presspectiva.6bfa498e.jpeg";